import { defineComponent } from 'vue'
import leftSideBar from './leftSideBar'

export default defineComponent({
    components: {
        leftSideBar
    }
})